// extracted by mini-css-extract-plugin
export default {"paymentsHeader":"styles_paymentsHeader__URyI3","paymentsHeader_title":"styles_paymentsHeader_title__WuUdo","paymentsHeader_actions":"styles_paymentsHeader_actions__LpN06"};